var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mails" } }, [
    _c(
      "div",
      { staticStyle: { display: "flex", width: "100%", height: "100%" } },
      [
        _c("NewMailInterface", {
          attrs: {
            mode: "folder-only",
            defaultMode: "normal",
            "default-selected-folder": _vm.selectedFolder,
            "default-selected-email-id": _vm.selectedEmailId,
          },
          on: {
            "folder-selected": _vm.changeFolder,
            "email-selected": _vm.changeEmail,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }